import { zIndex } from '@/theme/zIndex';
import { CSSProperties, ReactNode } from 'react';
import { Transition, TransitionStatus } from 'react-transition-group';
import styled, { css } from 'styled-components';

const duration = 300;

const defaultStyle: CSSProperties = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
};

const transitionStyles: Partial<Record<TransitionStatus, CSSProperties>> = {
  entering: { opacity: 1, zIndex: zIndex.modal },
  entered: { opacity: 1, zIndex: zIndex.modal },
  exiting: { opacity: 0, zIndex: zIndex.modal },
  exited: { opacity: 0, zIndex: -1 * zIndex.modal },
};

const mediaQueryPrint = css`
  @media print {
    overflow-y: visible !important;
    position: absolute;
    width: 100%;
  }
`;

interface WrapperProps {
  active?: boolean;
}

const Wrapper = styled.div<WrapperProps>`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #f1f5ff;
  max-height: 100%;
  opacity: ${(props) => (props.active ? '1' : '0')};
  transition: opacity 1000ms linear;
  top: 0;
  left: 0;
  border-left: 2px solid #f1f5ff;

  ${mediaQueryPrint}

  @media print {
    border: none;
  }
`;

const InnerWrapper = styled.div`
  border-radius: 5px;
  background-color: white;
  height: 100%;
  overflow-y: scroll;

  ${mediaQueryPrint}
`;

interface CleanModalProps {
  active: boolean;
  children: ReactNode;
  className?: string;
}

export function CleanModal({ active, children, className }: CleanModalProps) {
  return (
    <Transition in={active} timeout={duration}>
      {(state: TransitionStatus) => (
        <Wrapper
          active={active}
          className={className}
          style={{ ...defaultStyle, ...(transitionStyles[state] || {}) }}
        >
          <InnerWrapper>{children}</InnerWrapper>
        </Wrapper>
      )}
    </Transition>
  );
}
